export * from "./basePath";
export * from "./constants";
export * from "./cookiesNameConfig";
export * from "./endpoints/apiEndpoints";
export * from "./localStoreNameConfig";

const DEFAULT_HOST = process.env.NEXT_PUBLIC_DEFAULT_HOST || "localhost";

const APP_VERSION_NAME = process.env.NEXT_PUBLIC_APP_VERSION_NAME;
const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION;
const DEV_SERVER_IP = "76.13.212.252";

const CURRENCY = "£";
const PAGE_SIZE = 20;

const DEFAULT_IDEAL_TIMEOUT_MINUTES = 15;

const RATE_LIMIT_REQUESTS_DEFAULT = 60;
const RATE_LIMIT_WINDOW_DEFAULT = 60;

const RESEND_OTP_INTERVAL_SECONDS = parseInt(
  process.env.NEXT_PUBLIC_RESEND_OTP_INTERVAL || "60",
  10,
);

const DEFAULT_OTP_LENGTH = parseInt(
  process.env.NEXT_PUBLIC_OTP_LENGTH || "6",
  10,
);

export {
  APP_VERSION,
  APP_VERSION_NAME,
  CURRENCY,
  DEFAULT_HOST,
  DEFAULT_IDEAL_TIMEOUT_MINUTES,
  DEFAULT_OTP_LENGTH,
  DEV_SERVER_IP,
  PAGE_SIZE,
  RATE_LIMIT_REQUESTS_DEFAULT,
  RATE_LIMIT_WINDOW_DEFAULT,
  RESEND_OTP_INTERVAL_SECONDS,
};
